import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techRadarPlugin from '@backstage-community/plugin-tech-radar/alpha';
import authPlugin from '@backstage/plugin-auth';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { navModule } from './modules/nav';
import { techRadarModule } from './modules/tech-radar';
import { techDocsMermaidModule } from './modules/techdocs-mermaid';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using GitHub',
            apiRef: githubAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    notificationsPlugin,
    searchPlugin,
    orgPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    apiDocsPlugin,
    techdocsPlugin,
    techDocsMermaidModule,
    userSettingsPlugin,
    scaffolderPlugin,
    techRadarPlugin,
    techRadarModule,
    authPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
